var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_870_11210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.99996 13.3334C10.2216 13.3334 12.8333 10.7217 12.8333 7.50002C12.8333 4.27836 10.2216 1.66669 6.99996 1.66669C3.7783 1.66669 1.16663 4.27836 1.16663 7.50002C1.16663 10.7217 3.7783 13.3334 6.99996 13.3334Z",
    stroke: "#060200",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.95825 7.79169L6.12492 8.95835L9.04159 6.04169",
    stroke: "#060200",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_870_11210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveTick);
export default __webpack_public_path__ + "static/media/SaveTick.2f7623c317c34a00bab3a2137dbf46eb.svg";
export { ForwardRef as ReactComponent };